/**
 * Returns a new function, that caches the last return value.
 * The cached value is return, if all arguments are the _SAME_.
 * Optionally there can be given a comparision function to provide
 * as custom implementation of when two consecutive calls are treated
 * the same.
 *
 * @param {function} fn The function to wrap
 * @param {function} compare Optional comparision function for invocation arguments
 * @returns {function} The wrapped function
 */
export default function cachedFunction(fn, compare) {
  let cached = false
  let cachedArgs = []
  let cachedResult

  return function (...args) {
    if (cached) {
      if (!compare) {
        if (args.length === cachedArgs.length && args.every((a, i) => cachedArgs[i] === a)) {
          return cachedResult
        }
      } else if (compare(args, cachedArgs)) {
        return cachedResult
      }
    }

    cached = true
    cachedArgs = args
    cachedResult = fn.apply(this, args)
    return cachedResult
  }
}
